module.exports = __webpack_public_path__ + "media/images/design/images/icons/facebook-black-14150615fbf19b940f52520488fe40fb.png";